module.exports = __webpack_public_path__ + "media/images/shared/icon_question-f8fc46cbff01e8fa50eddc8012abd41d.svg";